module.exports = __webpack_public_path__ + "static/img/Jack-Sinclair.d5c2152.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Sinclair.jpg
// module id = Bdrx
// module chunks = 0